import React, { ChangeEvent, FC } from 'react'
import InputMask from 'react-input-mask'

export type BaseInputProps = {
	onChange?: (event: ChangeEvent<HTMLInputElement>) => void
	value: string
	error?: string
	type: string
	name: string
	placeholder: string
	maxLength?: number
	mask?: string
	disabled?: boolean
	maskChar?: string
}

export const BaseInputComponent: FC<BaseInputProps> = ({
	onChange,
	value,
	error,
	name,
	type,
	placeholder,
	maxLength,
	mask,
	disabled,
	maskChar,
	...props
}) => (
	<>
		{mask ? (
			<InputMask
				{...props}
				mask={mask}
				maskChar={maskChar}
				value={value}
				name={name}
				onChange={onChange}
				placeholder={placeholder}
			/>
		) : (
			<input
				{...props}
				type={type}
				name={name}
				id={name}
				onChange={onChange}
				placeholder={placeholder}
				maxLength={maxLength}
				value={value}
				readOnly={disabled}
			/>
		)}
		{error && <div className="error">{error}</div>}
	</>
)
